import React, { createContext, useContext, useState, useMemo } from 'react';

const Panel = createContext();

export const PanelContextProvider = ({ children }) => {
    const [panel, setPanel] = useState({
        name: 'Empty',
        content: null
    });

    const value = useMemo(() => ({
        panel,
        setPanel
    }), [panel]);
  
    return (
        <Panel.Provider 
            value={value}
        >
        {children}
        </Panel.Provider>
    );
};

export const usePanelContext = () => useContext(Panel);
